var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import * as dayjs from 'dayjs';
import TeleImage from "./images/img-tele.jpg";
import MoreTeleImage from "./images/more-tele.svg";
import PlayImage from "./images/play-tele.svg";
import FaviconRtl from "./images/favicon_rtl_outline.svg";
import FaviconRtl2 from "./images/favicon_rtl-zwee_outline_large.svg";
import ArrowLeftIcon from "../../common/images/arrow_left.svg";
import ArrowRightIcon from "../../common/images/arrow_right.svg";
import css from './style.pcss';
var RTLGrilleTele = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLGrilleTele, _LitElement);
  function RTLGrilleTele() {
    var _this;
    _classCallCheck(this, RTLGrilleTele);
    _this = _callSuper(this, RTLGrilleTele);
    _this.channel = 1;
    _this.date = dayjs().format('YYYY-MM-DD');
    _this.theme = 'light';
    _this.nonav = false;
    return _this;
  }
  _createClass(RTLGrilleTele, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _get(_getPrototypeOf(RTLGrilleTele.prototype), "connectedCallback", this).call(this);
            case 2:
              this._fetchData();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      this._apiUrl = `https://api-gate.rtl.lu/grille/tele/${this.channel}/${this.date}`;
      fetch(this._apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;

        //console.log(this.data);
      });
    }
  }, {
    key: "_setType",
    value: function _setType(e, channel) {
      this.channel = channel;
      this.shadowRoot.querySelector('.tabs-tele__item--active').classList.remove('tabs-tele__item--active');
      this.classList.add('tabs-tele__item--active');
      this._fetchData();
    }
  }, {
    key: "_setDate",
    value: function _setDate(e, date) {
      var newDate;
      if (date == '-1') {
        newDate = dayjs(this.date).subtract(1, 'day').format('YYYY-MM-DD');
      } else if (date == '+1') {
        newDate = dayjs(this.date).add(1, 'day').format('YYYY-MM-DD');
      } else {
        newDate = dayjs(date).format('YYYY-MM-DD');
      }
      this.date = newDate;
      this._fetchData();
    }
  }, {
    key: "_getCurrentTimeslot",
    value: function _getCurrentTimeslot(shows) {
      var now = dayjs().format('HHmm');

      //console.log(shows.length);
      for (var i = 0; i < shows.length; i++) {
        var time1 = shows[i].time.replace(':', '');
        var time2 = void 0;
        if (shows[i + 1]) {
          time2 = shows[i + 1].time.replace(':', '');
        } else {
          time2 = 2359;
        }
        if (now > time1 && now < time2) {
          return shows[i].time;
        }
      }
    }
  }, {
    key: "_showSubjects",
    value: function _showSubjects(e, index) {
      var subjects = this.shadowRoot.querySelector('.show-tele-sujets--' + index);
      subjects.classList.toggle('show-tele-sujets--visible');
      if (this.shadowRoot.querySelector('.js-subjects--' + index).innerHTML == 'Sujeten uweisen') {
        this.shadowRoot.querySelector('.js-subjects--' + index).innerHTML = 'Sujeten verstoppen';
      } else {
        this.shadowRoot.querySelector('.js-subjects--' + index).innerHTML = 'Sujeten uweisen';
      }
    }
  }, {
    key: "_renderSubjects",
    value: function _renderSubjects(sujets, index) {
      if (sujets) {
        return html(_t || (_t = _`
                <div class="show-tele-sujets show-tele-sujets--${0}">
                    ${0}
                </div>
            `), index, sujets.map(function (sujet) {
          return html(_t2 || (_t2 = _`
                        <div class="show-tele-sujets__sujet">
                            <div class="sujet-tele__time">${0}</div>
                            <div class="sujet-tele__info">
                                <div class="sujet-tele__detail">
                                    ${0}
                                    <div class="sujet-tele__header">
                                        <div class="sujet-tele__title">${0}</div>
                                        ${0}
                                    </div>
                                </div>
                            </div>
                        </div>
                    `), sujet.time, sujet.thumbnail != null ? html(_t3 || (_t3 = _`<div class="sujet-tele__media"><img class="sujet-tele__media-img" src="${0}" width="280" />
                                            ${0}
                                            </div>`), sujet.thumbnail, sujet.content_path ? html(_t4 || (_t4 = _`
                                                    <div class="show-tele__play"><a class="show-play__button" href="${0}"><img class="show-play__img show-play__img--sujet" src="${0}" alt="Replay"/></a></div>
                                            `), sujet.content_path, PlayImage) : ``) : ``, sujet.title, sujet.header);
        }));
      }
    }
  }, {
    key: "_renderShow",
    value: function _renderShow(show, live, index) {
      var _this3 = this;
      var showLink = false;
      if (show.main_content && show.main_content.content_path) showLink = true;
      return html(_t5 || (_t5 = _`
            <div class="grille-tele__show show-tele${0}">
                <div class="show-tele__time">${0}</div>
                <div class="show-tele__info show-tele-info">


                    <div class="show-tele-info__detail">
                        ${0}
                        <div class="show-tele__header">
                            <div class="show-tele__title-live">
                                <div class="show-tele-info__title">${0}</div>
                                ${0}
                            </div>
                            <div class="show-tele-info__info">
                                ${0}

                                <div class="show-tele-button__container">
                                    ${0}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="show-tele-info__info show-tele-info__info--mobile">
                        ${0}

                        <div class="show-tele-button__container">
                            ${0}
                        </div>
                    </div>

                    ${0}
                </div>
            </div>
        `), show.time == live ? ` grille-tele__show--live` : ``, show.time, show.image_url != null ? html(_t6 || (_t6 = _`<div class="show-tele__media"><img class="show-tele__media-img" src="${0}" width="280" />
                                ${0}
                                </div>`), show.image_url, showLink ? html(_t7 || (_t7 = _`
                                        <div class="show-tele__play"><a class="show-play__button" href="${0}"><img class="show-play__img" src="${0}" alt="Replay"/></a></div>
                                `), show.main_content.content_path, PlayImage) : ``) : html(_t8 || (_t8 = _`
                                <div class="show-tele__media"><img class="show-tele__media-img" src="${0}" alt="TV"/>
                                ${0}
                                </div>
                        `), TeleImage, showLink ? html(_t9 || (_t9 = _`
                                        <div class="show-tele__play"><a class="show-play__button" href="${0}"><img class="show-play__img" src="${0}" alt="Replay"/></a></div>
                                `), show.main_content.content_path, PlayImage) : ``), show.name, show.time == live ? html(_t10 || (_t10 = _`<div class="show-tele__live"><a href="/tele/live">LIVE</a></div>`)) : ``, unsafeHTML(show.description), show.content.length ? html(_t11 || (_t11 = _`
                                        <div class="show-tele-button" @click=${0}>
                                            <div class="show-tele-button__more-content">
                                                <img class="show-tele-button__img" src="${0}" alt="more"/>
                                                <div class="show-tele-button__p js-subjects--${0}">Sujeten uweisen</div>
                                            </div>
                                        </div>
                                    `), function (e) {
        return _this3._showSubjects(e, index);
      }, MoreTeleImage, index) : ``, unsafeHTML(show.description), show.content.length ? html(_t12 || (_t12 = _`
                                <div class="show-tele-button" @click=${0}>
                                    <div class="show-tele-button__more-content">
                                        <img class="show-tele-button__img" src="${0}" alt="more"/>
                                        <div class="show-tele-button__p js-subjects--${0}">Sujeten uweisen</div>
                                    </div>
                                </div>
                            `), function (e) {
        return _this3._showSubjects(e, index);
      }, MoreTeleImage, index) : ``, this._renderSubjects(show.content, index));
    }
  }, {
    key: "_showDatepicker",
    value: function _showDatepicker(e) {
      // Datepicker
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      if (this.data == undefined) return html(_t13 || (_t13 = _`Loading...`));
      var shows = this.data.items;
      var live;
      if (this.date == dayjs().format('YYYY-MM-DD')) {
        live = this._getCurrentTimeslot(shows);
      }
      return html(_t14 || (_t14 = _`
            <style>${0}</style>

            <div class="grille-tele flavor--${0}">
                <div class="grille-tele__nav nav-tele" align="center">
                    ${0}
                    <nav class="nav-tele__day-selector day-tele-selector">
                        <div class="day-tele-selector__prev day-tele-selector__prev--justify" @click=${0}><img class="day-tele-selector__prev-button" src="${0}" alt="arrow prev"/></div>
                        <div class="day-tele-selector__today" @click=${0}>${0}</div>
                        <div class="day-tele-selector__prev" @click=${0}><img class="day-tele-selector__prev-button" src="${0}" alt="arrow prev"/></div>
                    </nav>
                    <div class="datepicker"></div>
                </div>
                ${0}
            </div>
        `), css, this.theme, !this.nonav ? html(_t15 || (_t15 = _`
                    <nav class="nav-tele__tabs tabs-tele">
                        <div class="tabs-tele__item${0}" @click=${0}> <img class="tabs-tele__item__img-rtl" src="${0}" alt="Logo RTL"/></div>
                        <div class="tabs-tele__item${0}" @click=${0}> <img class="tabs-tele__item__img-rtlzwee" src="${0}" alt="Logo RTL Zwee"/></div>
                    </nav>
                    `), this.channel == 1 ? ` tabs-tele__item--active` : ``, function (e) {
        return _this4._setType(e, 1);
      }, FaviconRtl, this.channel == 2 ? ` tabs-tele__item--active` : ``, function (e) {
        return _this4._setType(e, 2);
      }, FaviconRtl2) : ``, function (e) {
        return _this4._setDate(e, '-1');
      }, ArrowLeftIcon, function (e) {
        return _this4._showDatepicker(e);
      }, dayjs(this.date).format('DD.MM.YYYY'), function (e) {
        return _this4._setDate(e, '+1');
      }, ArrowRightIcon, shows.map(function (show, index) {
        return _this4._renderShow(show, live, index);
      }));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        channel: {
          type: Number
        },
        date: {
          type: String
        },
        theme: {
          type: String
        },
        nonav: {
          type: Boolean
        }
      };
    }
  }]);
  return RTLGrilleTele;
}(LitElement);
export { RTLGrilleTele as default };
window.customElements.define('rtl-grille-tele', RTLGrilleTele);